/**
 * Thin shim over `components/LoadingScreen` kept so the old route
 * orchestrator's call sites (`<LoadingStep />`) don't have to change
 * shape. The actual surface is the shared marine + bouncing-logo
 * screen — see LoadingScreen.tsx (white execute theme).
 */
import LoadingScreen from '@/components/LoadingScreen';

interface LoadingStepProps {
  label?: string;
  reserveCtaSlot?: boolean;
}

export default function LoadingStep({ label, reserveCtaSlot }: LoadingStepProps) {
  return <LoadingScreen label={label} reserveCtaSlot={reserveCtaSlot} />;
}
